<template>
  <div
    class="flex flex-grow rounded-md border-2 border-transparent bg-off-white p-0"
    :class="{ activeButton: active }"
  >
    <label
      class="container overflow-hidden"
      :class="{ activeButtonText: active, 'container-thin': thin }"
    >
      <slot name="beforeText" />
      <div
        class="truncate"
        :title="item"
      >
        {{ item }}
      </div>
      <slot name="afterText" />
      <input
        type="checkbox"
        :name="name"
        :value="item"
        :checked="active"
        :data-model-id="modelId"
        @click="handleSelect"
      />
      <span
        class="checkmark"
        :class="{ 'checkmark-thin': thin }"
      />
    </label>
  </div>
</template>

<script>
export default {
  name: 'ContactRadioButton',
  props: {
    item: String,
    modelId: {
      type: Number,
      required: false,
    },
    activeItems: Array,
    handleSelect: {
      type: Function,
    },
    name: [String, Number],
    active: [Boolean, Object],
    thin: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>
/* Custom CSS for Checkboxes */
/* Template used from W3 schools https://www.w3schools.com/howto/tryit.asp?filename=tryhow_css_custom_checkbox */
/* The container */
.container {
  @apply relative block flex h-12 cursor-pointer items-center py-3 pl-12 pr-4 text-left text-xs text-body-color sm:text-sm;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.container.container-thin {
  @apply relative block flex cursor-pointer items-center py-3 pl-12 pr-4 text-left text-xs text-body-color sm:text-sm;
  height: 2.65rem;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
  @apply absolute h-0 w-0 cursor-pointer opacity-0;
}

/* Create a custom checkbox */
.checkmark {
  @apply absolute left-2 top-0 h-6 w-6 rounded-md bg-white;
  top: 50%;
  transform: translate(0, -50%);
}

/* When the checkbox is checked, add a yellow background */
.container input:checked ~ .checkmark {
  @apply bg-yellow-500;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 8px;
  top: 2px;
  width: 9px;
  height: 15px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.container .checkmark.checkmark-thin:after {
  left: 8px;
  top: 2px;
}

.activeButton {
  /* @apply flex flex-wrap p-3 bg-white border-yellow-500 border-2 rounded-md; */
  @apply flex flex-wrap rounded-md border-2 border-yellow-500 bg-white;
  border-color: #f8c617 !important;
  background-color: white !important;
}

.activeButtonText {
  @apply text-dark-gray;
}
</style>
